// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bff_a bhb_vc bhb_rm bhb_wf"};